import { useQuery } from "@tanstack/react-query";
import { AdministrationService } from "../../services/administrationService";
import { User } from "../../models/user.model";

const administrationService = new AdministrationService();

export const useCurrentUser = () => {
  return useQuery({
    queryKey: ["user", "current"],
    queryFn: async (): Promise<User> => {
      administrationService.clearCache();
      return administrationService.getCurrentPerson();
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: (failureCount, error: any) => {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return false;
      }
      return failureCount < 2;
    },
  });
};
